// src/components/FormikInput.js

import React, { useState } from "react"
import { FormGroup, Label, Input, FormFeedback } from "reactstrap"

const FormikInput = ({
  label,
  name,
  max = 255,
  placeholder,
  formik,
  onChange,
  mask, // Opcional: si usas InputMask
  showCharacterCounter = false,
  isLoading,
  ...props
}) => {
  const [showPassword, setShowPassword] = useState(false)
  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword)
  }

  return (
    <FormGroup>
      <Label htmlFor={name}>{label}</Label>
      {!isLoading ? (
        <div className="input-group">
          <Input
            type={showPassword ? "text" : "password"}
            name={name}
            id={name}
            placeholder={placeholder}
            value={formik.values[name]}
            onChange={onChange || formik.handleChange}
            onBlur={formik.handleBlur}
            invalid={formik.touched[name] && !!formik.errors[name]}
            maxLength={max} // Limita la entrada a max caracteres
            autoComplete="off"
            {...props}
          />{" "}
          <div
            className="input-group-text"
            style={{ cursor: "pointer" }}
            onClick={togglePasswordVisibility}
          >
            <i
              className={`fas ${showPassword ? "fa-eye" : "fa-eye-slash"}`}
            ></i>
          </div>
          {showCharacterCounter ? (
            <div className="text-end">
              {formik.values[name].length}/{max}
            </div>
          ) : null}
        </div>
      ) : (
        <div>
          <p aria-hidden="true" className="mt-2">
            <span className="placeholder col-12 placeholder-lg placeholder-glow"></span>
          </p>
        </div>
      )}
      {formik.touched[name] && formik.errors[name] && (
        <FormFeedback>{formik.errors[name]}</FormFeedback>
      )}
    </FormGroup>
  )
}

export default FormikInput
